module.exports = __webpack_public_path__ + "img/no-tickets.91ea7a36.svg";